var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircleLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7049 9.00992L10.7866 13.9283L8.66326 11.8049C8.34909 11.4908 7.82909 11.4908 7.51492 11.8049C7.20076 12.1191 7.20076 12.6391 7.51492 12.9533L10.2124 15.6508C10.3749 15.8133 10.5808 15.8891 10.7866 15.8891C10.9924 15.8891 11.1983 15.8133 11.3608 15.6508L16.8533 10.1583C17.1674 9.84408 17.1674 9.32408 16.8533 9.00992C16.5391 8.69575 16.0191 8.69575 15.7049 9.00992Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.2749C6.09604 1.2749 1.29688 6.06323 1.29688 11.9782C1.29688 17.8824 6.08521 22.6816 12.0002 22.6816C17.9152 22.6816 22.7035 17.8932 22.7035 11.9782C22.7035 6.06323 17.9044 1.2749 12.0002 1.2749ZM12.0002 21.2624C6.87604 21.2624 2.70521 17.0916 2.70521 11.9674C2.70521 6.84324 6.87604 2.68324 12.0002 2.68324C17.1244 2.68324 21.2952 6.85407 21.2952 11.9782C21.2952 17.1024 17.1244 21.2624 12.0002 21.2624Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleLine);
export default __webpack_public_path__ + "static/media/icon_check_circle_line.5db1c102.svg";
export { ForwardRef as ReactComponent };